import {
  OnInit,
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  AircraftEventBusinessPersonAudit,
  AircraftEventBusinessPersonSkeleton
} from '../../+models/aircraft-event-audit.model';

@Component({
  selector: 'sd-portal-aircraft-event-business-person-audit-list',
  templateUrl: './aircraft-event-business-person-audit-list.component.html',
  styleUrls: ['./aircraft-event-business-person-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AircraftEventBusinessPersonAuditListComponent implements OnInit {
  @Input() aircraftEventBusinessPerson: AircraftEventBusinessPersonSkeleton;
  @Input() loading: boolean;
  @Input() aircraftEventBusinessPersonAudits: AircraftEventBusinessPersonAudit[];

  @Output() loadAircraftEventBusinessPerson = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadAircraftEventBusinessPerson.emit(
      this.aircraftEventBusinessPerson.aircraftEventBusinessPersonId
    );
  }

  onNextPage() {
    this.nextPage.emit(this.aircraftEventBusinessPerson.aircraftEventBusinessPersonId);
  }
}
